<template>
  <section
    class="mobile_add_new_head bg--blue tx--bege center flex flex--content--center relative"
    style="height: 100px;"
  >
    <a
      v-show="!isEditMode || (isEditMode && currentStep !== 2)"
      class="mobile-back-btn"
      @click="onPrevStage"
    >
      <ArrowBack />
    </a>
    <div>
      <div class="title">{{ isEditMode ? "עריכת" : "יצירת" }} תור לניתוח</div>
      <Steps />
    </div>
    <div class="popup_close close-animate mobile-close-btn">
      <a @click="goBackRoute"><CloseSvg /></a>
    </div>
  </section>
</template>

<script>
import ArrowBack from "@/assets/img/svg/arrow_r.svg";
import Steps from "@/components/Dashboard/Surgery/AddSurgery/Layout/Steps.vue";
import CloseSvg from "@/assets/img/svg/close.svg";
import { getHash } from "@/utilities/hash.js";
import { mapState, mapMutations } from "vuex";

export default {
  components: { ArrowBack, CloseSvg, Steps },
  computed: {
    ...mapState("Surgery", ["isEditMode", "currentStep"])
  },
  methods: {
    ...mapMutations("Surgery", ["SET_CURRENT_STEP"]),
    /**
     * Navigate back to surgeries list with hash preserved
     */
    goBackRoute() {
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard/surgeries");
      }
      const hash = getHash({});
      return this.$router.push("/dashboard/surgeries#" + hash);
    },
    /**
     * Handle step navigation back
     */
    async onPrevStage() {
      if (this.currentStep === 2) {
        this.SET_CURRENT_STEP(1);
        this.$router.push({ name: "surg-add" });
      } else if (this.currentStep > 2) {
        if (this.currentStep === 3) {
          await this.$parent.$refs.surgeryDetails?.addBlockDefaults();
        }
        this.SET_CURRENT_STEP(this.currentStep - 1);
      }
    }
  }
};
</script>

<style scoped>
.mobile-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 42px;
  height: 42px;
  position: absolute;
  top: 8px;
  right: 5px;
  text-align: center;
  cursor: pointer;
}

.mobile-back-btn :deep(svg) {
  width: 12px;
  height: auto;
  display: block;
}

.mobile-back-btn :deep(path) {
  fill: #efefea;
}

.mobile-close-btn a {
  right: unset !important;
  left: 5px !important;
  top: 8px !important;
}
</style>
